import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { CiHeart } from 'react-icons/ci';
import { PiChatCircleDots } from 'react-icons/pi';
import { FaHeart } from 'react-icons/fa';
import { FiTrash2, FiFile } from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';
import { getBookcommunityDefaultBoardTexts, deleteBookcommunityDefaultBoardText, getBookcommunityDefaultBoardText, getBookcommunityDefaultBoardTextComments, createBookcommunityDefaultBoardTextComment, modifyBookcommunityDefaultBoardTextComment, deleteBookcommunityDefaultBoardTextComment, getBookcommunityLikedBoardTextIds, addBookcommunityBoardTextLike, deleteBookcommunityBoardTextLike, getBookcommunityBoardTextReport, addBookcommunityBoardTextReport, deleteBookcommunityBoardTextReport } from '../api/BookcommunityApi';
import { getAccessToken, getNativeWebview } from '../react-queries/queries';
import { processApiResponse, ERROR_CODES } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import { useUserInfoQuery } from '../react-queries/queries';
import { FiEdit3 } from 'react-icons/fi';
import { FaTimes } from 'react-icons/fa';
import MoimDetailCommunityFreeboardEditPage from './MoimDetailCommunityFreeboardEditPage';
import { launchUrl } from '../api/native/NativeApis';

const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;



// 커뮤니티 탭용 스타일
const CommunityContent = styled.div`
  padding: 20px;
`;


const CommentsContainer = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  padding-left: 24px;
  border-top: 1px solid #eee;
`;

const CommentItem = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid #f5f5f5;
  
  &:last-child {
    border-bottom: none;
  }
`;

const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

const CommentHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CommentHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CommentAuthor = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #333;
`;

const CommentDate = styled.div`
  font-size: 11px;
  color: #999;
`;

const CommentContent = styled.div`
  font-size: 13px;
  color: #555;
  line-height: 1.4;
  padding-left: 0;
  margin-top: 4px;
`;

const CommentInputContainer = styled.div`
  margin-top: 12px;
  padding-top: 12px;
`;

const CommentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CommentInput = styled.input`
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  outline: none;
  
  &:focus {
    border-color: #244AC2;
  }
  
  &::placeholder {
    color: #999;
  }
`;

const CommentSubmitButton = styled.button`
  background: #244AC2;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #1a3a9a;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;


const EditButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f5f5f5;
    color: #244AC2;
  }
`;


const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f5f5f5;
    color: #e74c3c;
  }
`;

const ReportButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f5f5f5;
    color: #f39c12;
  }
`;


const CommunityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;
  background: #f8f9fa;
  padding: 8px 20px;
`;

const BookCount = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;

const SortDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #222;
  cursor: pointer;
`;

const BookItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
`;


const BookItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;


const BookItemDesc = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;

const BookItemStats = styled.div`
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #999;
`;

const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const BoardEditModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const BoardEditModal = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 20px 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 320px;
`;




/*

const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`; */

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const EditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;


// 댓글 수정 모달 - BookDetail 페이지와 동일 스타일
const CommentEditModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const CommentEditModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
`;

const CommentEditModalTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #222;
`;

const CommentEditTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #244AC2;
  }
`;

const CommentEditModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid #f0f0f0;
`;

const CommentEditModalButton = styled.button`
  background: #eee;
  color: #555;
  border: none;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  min-width: 64px;
  &.cancel {
    background: #f5f5f5;
    color: #666;
    
    &:hover {
      background: #e0e0e0;
    }
  }
  
  &.save {
    background: #244AC2;
    color: white;
    
    &:hover {
      background: #1e3a8a;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;

const ReportModalTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #244AC2;
  }
`;

const AttachmentList = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const AttachmentThumbnailLink = styled.a`
  line-height: 0;
  text-decoration: none;
  flex-shrink: 0;
`;

const AttachmentThumbnailImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #eee;
  display: block;
  cursor: pointer;
`;

const AttachmentVideo = styled.video`
  width: 100%;
  max-height: 220px;
  border-radius: 4px;
  background: #000;
  display: block;
`;

const AttachmentVideoWrap = styled.div`
  flex: 1 1 100%;
`;

const AttachmentItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #eee;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: #666;
  background: #fafafa;
  flex-shrink: 0;

  &:hover {
    border-color: #244AC2;
  }
`;

const AttachmentFileIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 4px;
  box-sizing: border-box;
`;

const AttachmentFileName = styled.span`
  font-size: 9px;
  color: #888;
  margin-top: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;







function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const PAGE_SIZE = 10;
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm', 'm4v', 'avi', 'mkv', '3gp', 'quicktime'];

const isVideoFile = (file) => {
  const ext = (file.fileExt || '').toLowerCase().replace(/^\./, '');
  const mimeExt = ext.includes('/') ? ext.split('/')[1] : ext;
  if (VIDEO_EXTENSIONS.includes(mimeExt)) {
    return true;
  }
  const name = (file.fileName || '').toLowerCase();
  return VIDEO_EXTENSIONS.some(e => name.endsWith('.' + e));
};

const renderAttachment = (file, index) => {
  const fileName = file.fileName || `첨부파일${index + 1}`;
  const downloadUrl = file.fileDownloadUrl;
  const mediaUrl = file.fileUrl || downloadUrl;
  const openUrl = downloadUrl || mediaUrl;
  const downloadProps = {
    href: openUrl || '#',
    download: fileName,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (e) => {
      e.stopPropagation();
      if (!openUrl) {
        e.preventDefault();
        return;
      }
      if (getNativeWebview()) {
        e.preventDefault();
        launchUrl(openUrl);
      }
    },
  };

  if (isVideoFile(file) && mediaUrl) {
    return (
      <AttachmentVideoWrap key={file.id || index}>
        <AttachmentVideo
          src={mediaUrl}
          controls
          playsInline
          preload="metadata"
          onClick={(e) => e.stopPropagation()}
        />
      </AttachmentVideoWrap>
    );
  }

  if (file.fileUrl) {
    return (
      <AttachmentThumbnailLink key={file.id || index} {...downloadProps} title={fileName}>
        <AttachmentThumbnailImage src={file.fileUrl} alt={fileName} />
      </AttachmentThumbnailLink>
    );
  }

  return (
    <AttachmentItem key={file.id || index} {...downloadProps} title={fileName}>
      <AttachmentFileIcon>
        <FiFile size={22} color="#888" />
        <AttachmentFileName>{fileName}</AttachmentFileName>
      </AttachmentFileIcon>
    </AttachmentItem>
  );
};

export default function MoimDetailCommunityFreeboardPage({bookCommunityId, refreshFlag}) {
  const [expandedPostId, setExpandedPostId] = useState(null);
  const [likedPosts, setLikedPosts] = useState(new Set());
  const [postLikes, setPostLikes] = useState({});
  const [showComments, setShowComments] = useState(new Set());
  const [commentInputs, setCommentInputs] = useState({});
  const [freeBoardData, setFreeBoardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [sortByNew, setSortByNew] = useState(true);
  const [showFreeboardEditModal, setShowFreeboardEditModal] = useState(false);
  const [editingPost, setEditingPost] = useState(null);
  const [commentsData, setCommentsData] = useState({}); // 각 게시글별 댓글 데이터
  const [loadingComments, setLoadingComments] = useState(new Set()); // 댓글 로딩 중인 게시글 ID들
  const [submittingComment, setSubmittingComment] = useState(new Set()); // 댓글 제출 중인 게시글 ID들
  const [likingPosts, setLikingPosts] = useState(new Set()); // 좋아요 동작 중인 게시글 ID들
  const [showCommentEditModal, setShowCommentEditModal] = useState(false);
  const [editingComment, setEditingComment] = useState(null); // { postId, comment }
  const [editCommentText, setEditCommentText] = useState('');
  const [savingCommentEdit, setSavingCommentEdit] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportTarget, setReportTarget] = useState(null); // { boardTextId, label }
  const [reportText, setReportText] = useState('');
  const [hasExistingReport, setHasExistingReport] = useState(false);
  const [savingReport, setSavingReport] = useState(false);
  const [deletingReport, setDeletingReport] = useState(false);
  const {data: userInfo} = useUserInfoQuery();


  // API에서 자유게시판 데이터 가져오기 (첫 페이지)
  const fetchFreeBoardData = async (isRefresh = false) => {
    if (!bookCommunityId) return;
    
    if (isRefresh) {
      setIsLoading(true);
      setCurrentPage(0);
      setHasMore(true);
    } else {
      setIsLoadingMore(true);
    }
    setError('');
    
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setError('인증 토큰을 가져올 수 없습니다.');
        return;
      }

      const page = isRefresh ? 0 : currentPage;
      const response = await getBookcommunityDefaultBoardTexts(accessToken, bookCommunityId, page, PAGE_SIZE, sortByNew);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success && processedResponse.data) {
        setTotalCount(processedResponse?.page?.total || 0);
        const newData = processedResponse.data;
        
        if (isRefresh) {
          // 새로고침인 경우 기존 데이터 교체
          setFreeBoardData(newData);
        } else {
          // 추가 로딩인 경우 기존 데이터에 추가
          setFreeBoardData(prev => [...prev, ...newData]);
        }
        
        // 좋아요 수 업데이트
        const likesData = {};
        newData.forEach(post => {
          likesData[post.id] = post.likeCnt || 0;
        });
        setPostLikes(prev => ({ ...prev, ...likesData }));
        
        // 더 가져올 데이터가 있는지 확인
        setHasMore(newData.length === PAGE_SIZE);
        setCurrentPage(page + 1);
      } else {
        if (response?.errorCode === ERROR_CODES.UNAUTHORIZATIONERROR) {
          setError('모임 멤버만 볼 수 있는 공간입니다.\n 참여 신청 후 멤버들과 함께 이야기를 나눠보세요!');
        } else {
          setError(processedResponse.errorMessage || '데이터를 가져오는데 실패했습니다.');
        }
      }
    } catch (error) {
      console.error('자유게시판 데이터 가져오기 오류:', error);
      setError(error.message || '데이터를 가져오는 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };

  // 더 많은 데이터 로드
  const loadMoreData = () => {
    if (!isLoadingMore && hasMore) {
      fetchFreeBoardData(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      fetchFreeBoardData(true); // 새로고침으로 시작
      try {
        if (!bookCommunityId) return;
        const { accessToken } = await getAccessToken();
        if (!accessToken) return;
        const resp = await getBookcommunityLikedBoardTextIds(accessToken, bookCommunityId);
        const pr = processApiResponse(resp);
        if (pr.success && Array.isArray(pr.data)) {
          setLikedPosts(new Set(pr.data));
        }
      } catch (e) {
        console.error('초기 좋아요 데이터 로드 실패:', e);
      }
    };
    init();
  }, [bookCommunityId, refreshFlag, sortByNew]);

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      if(hasMore && !isLoading && !isLoadingMore) {
         loadMoreData();
      }
    };

    // 스로틀링을 위한 타이머
    let timeoutId;
    const throttledHandleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
    
      if (scrollHeight - scrollTop <= clientHeight + 100 ) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        console.log('handleScroll');
        timeoutId = setTimeout(handleScroll, 100);
      }   
    };
    //console.log('handleScroll register', document.getElementById('community-moim-page-modal'));

    //window.addEventListener('scroll', throttledHandleScroll);
    const modalEle = document.getElementById('noobook-page-modal')
    modalEle?.addEventListener('scroll', throttledHandleScroll);
    return () => {
      modalEle?.removeEventListener('scroll', throttledHandleScroll);
      //window.removeEventListener('scroll', throttledHandleScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoadingMore, hasMore, currentPage]);


  // 하트 클릭 핸들러 (자유게시판)
  const handleLikeClick = async (postId, e) => {
    e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
    
    if (likingPosts.has(postId)) return; // 중복 클릭 방지
    setLikingPosts(prev => new Set([...prev, postId]));
    setIsLoading(true); // 로딩 휠 표시

    const isCurrentlyLiked = likedPosts.has(postId);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        throw new Error('인증 토큰을 가져올 수 없습니다.');
      }

      if (isCurrentlyLiked) {
        const resp = await deleteBookcommunityBoardTextLike(accessToken, postId);
        const pr = processApiResponse(resp);
        if (!pr.success && resp?.errorCode !== ERROR_CODES.NOTFOUND) {
          throw new Error(pr.errorMessage || '좋아요 취소에 실패했습니다.');
        }
        // 성공 시 상태 반영
        setLikedPosts(prev => {
          const newSet = new Set(prev);
          newSet.delete(postId);
          return newSet;
        });
        setPostLikes(prev => ({ ...prev, [postId]: Math.max(0, (prev[postId] || 1) - 1) }));
      } else {
        const resp = await addBookcommunityBoardTextLike(accessToken, postId);
        const pr = processApiResponse(resp);
        if (!pr.success) {
          throw new Error(pr.errorMessage || '좋아요에 실패했습니다.');
        }
        // 성공 시 상태 반영
        setLikedPosts(prev => new Set([...prev, postId]));
        setPostLikes(prev => ({ ...prev, [postId]: (prev[postId] || 0) + 1 }));
      }
    } catch (err) {
      console.error('좋아요 처리 중 오류:', err);
      setError(err.message || '좋아요 처리 중 오류가 발생했습니다.');
    } finally {
      setLikingPosts(prev => { const s = new Set(prev); s.delete(postId); return s; });
      setIsLoading(false); // 로딩 휠 숨김
    }
  };

  

  // 댓글 데이터 가져오기
  const fetchComments = async (postId) => {
    if (loadingComments.has(postId) || commentsData[postId]) {
      return; // 이미 로딩 중이거나 데이터가 있으면 중복 요청 방지
    }

    setLoadingComments(prev => new Set([...prev, postId]));

    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        console.error('인증 토큰을 가져올 수 없습니다.');
        return;
      }

      const response = await getBookcommunityDefaultBoardTextComments(accessToken, postId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success && processedResponse.data) {
        setCommentsData(prev => ({
          ...prev,
          [postId]: processedResponse.data
        }));
      } else {
        console.error('댓글 데이터 가져오기 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('댓글 데이터 가져오기 오류:', error);
    } finally {
      setLoadingComments(prev => {
        const newSet = new Set(prev);
        newSet.delete(postId);
        return newSet;
      });
    }
  };

  // 댓글 클릭 핸들러
  const handleCommentClick = async (postId, e) => {
    e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
    
    if (showComments.has(postId)) {
      // 댓글이 보이고 있다면 숨기기
      setShowComments(prev => {
        const newSet = new Set(prev);
        newSet.delete(postId);
        return newSet;
      });
    } else {
      // 댓글 보이기
      setShowComments(prev => new Set([...prev, postId]));
      
      // 댓글 데이터가 없으면 가져오기
      if (!commentsData[postId]) {
        await fetchComments(postId);
      }
    }
  };

  // 댓글 입력 핸들러
  const handleCommentInputChange = (postId, value) => {
    setCommentInputs(prev => ({
      ...prev,
      [postId]: value
    }));
  };

  // 댓글 제출 핸들러
  const handleCommentSubmit = async (postId, e) => {
    e.preventDefault();
    const commentText = commentInputs[postId]?.trim();
    
    if (!commentText) return;
    
    // 이미 제출 중이면 중복 제출 방지
    if (submittingComment.has(postId)) return;
    
    setSubmittingComment(prev => new Set([...prev, postId]));
    
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        console.error('인증 토큰을 가져올 수 없습니다.');
        return;
      }

      // 댓글 작성 요청 데이터
      const commentData = {
        boardText: commentText
      };

      const response = await createBookcommunityDefaultBoardTextComment(accessToken, postId, commentData);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        // 댓글 작성 성공 시 입력창 초기화
        setCommentInputs(prev => ({
          ...prev,
          [postId]: ''
        }));
        
        // 댓글 목록 새로고침
        commentsData[postId] = null;
        await fetchComments(postId);
        
        console.log('댓글 작성 성공:', postId, commentText);
      } else {
        console.error('댓글 작성 실패:', processedResponse.errorMessage);
        setError(processedResponse.errorMessage || '댓글 작성에 실패했습니다.');
      }
    } catch (error) {
      console.error('댓글 작성 중 오류:', error);
      setError('댓글 작성에 실패했습니다.');
    } finally {
      setSubmittingComment(prev => {
        const newSet = new Set(prev);
        newSet.delete(postId);
        return newSet;
      });
    }
  };

  // 글 수정 핸들러
  const handleEditPost = (post) => {
    if(post && post.id) {
      setEditingPost(post);
      setShowFreeboardEditModal(true);
    }
   
    //setEditingPost(post);
    //setEditCommentText(comment.bookComment || '');
    //navigate(`/moim-detail-community-freeboard-edit?bookCommunityId=${bookCommunityId}&bookCommunityBoardTextId=${post.id}`);
  };

/*
  const handleSaveEditPost = async () => {
    if (!editCommentText.trim()) {
      setError('댓글 내용을 입력해주세요.');
      return;
    }

    if (!editingComment) {
      setError('수정할 댓글 정보가 없습니다.');
      return;
    }

    try {
      setSavingEdit(true);
      const { accessToken } = await getAccessToken();
      
      const commentData = {
        memberId: editingComment.memberId,
        bookComment: editCommentText.trim()
      };
      
      const response = await modifyBookcommunityBookComment(
        accessToken || '', 
        editingComment.id, 
        commentData
      );
      
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        // 댓글 수정 성공 시 댓글 목록 새로고침
        if(onModified) {
          onModified(true);
        }
        editingComment.bookComment = editCommentText.trim();
        handleCloseEditModal();
        //loadComments(true);
      } else {
        setError(processedResponse.errorMessage || '댓글 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('댓글 수정 중 오류:', err);
      setError('댓글 수정에 실패했습니다.');
    } finally {
      setSavingEdit(false);
    }
  };*/

  const getBoardText = async (boardTextId) => {
    if(!boardTextId) {
      return null;
    }
    if(isLoading) {
      return null;
    }
    setIsLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        return null;
      }
      const response = await getBookcommunityDefaultBoardText(accessToken || '', boardTextId);
      const processedResponse = processApiResponse(response);
      if(processedResponse.success) {
        return processedResponse.data;
      }
    } catch (error) {
      console.error('게시글 데이터 로드 중 오류:', error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };




  const closeFreeboardEditModal = async(modified) => {
    setShowFreeboardEditModal(false);
    if(modified) {
      var boardText = await getBoardText(editingPost.id);
      if(boardText) {
        editingPost.boardText = boardText.boardText;
        editingPost.files = boardText.files;
        setEditingPost(editingPost);
      }
    }
  };


  // 글 삭제 핸들러
  const handleDeletePost = async (postId, e) => {
    e.stopPropagation();
    if (!window.confirm('정말로 이 글을 삭제하시겠습니까?')) {
      return;
    }
      // TODO: 실제 글 삭제 API 호출 구현 필요
    console.log('글 삭제:', postId);
      // 삭제 후 데이터 새로고침
      //fetchFreeBoardData(true);
      try {
        const { accessToken } = await getAccessToken();
        const response = await deleteBookcommunityDefaultBoardText(
          accessToken || '', 
          postId
        );
        
        const processedResponse = processApiResponse(response);
        
        if (processedResponse.success || response.errorCode === ERROR_CODES.NOTFOUND) {
          
          //console.log('delete : ', response.errorCode, ERROR_CODES.NOTFOUND);
          for(let i = 0; i < freeBoardData.length; i++) {
            if(freeBoardData[i].id === postId) {
              freeBoardData.splice(i, 1);
              break;
            }
          }
          setFreeBoardData([...freeBoardData]);
        } else {
          setError(processedResponse.errorMessage || '게시글 삭제에 실패했습니다.');
        }
      } catch (err) {
        console.error('게시글 삭제 중 오류:', err);
        setError('게시글 삭제에 실패했습니다.');
      }
    
  };

  // 댓글 삭제 핸들러
  const handleDeleteComment = (postId, commentId, e) => {
    e.stopPropagation();
    if (window.confirm('정말로 이 댓글을 삭제하시겠습니까?')) {
      // TODO: 실제 댓글 삭제 API 호출 구현 필요
      console.log('댓글 삭제:', postId, commentId);
    }
  };

  const closeReportModal = () => {
    setShowReportModal(false);
    setReportTarget(null);
    setReportText('');
    setHasExistingReport(false);
  };

  const openReportModal = async (boardTextId, label, e) => {
    if (e) {
      e.stopPropagation();
    }
    if (!boardTextId) {
      return;
    }
    setIsLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setError('인증 토큰을 가져올 수 없습니다.');
        return;
      }
      const resp = await getBookcommunityBoardTextReport(accessToken, boardTextId);
      const pr = processApiResponse(resp);
      const existingReport = pr.success ? pr.data : null;
      setReportTarget({ boardTextId, label });
      setHasExistingReport(!!existingReport);
      setReportText(existingReport?.bookcommunityBoardTextReport || '');
      setShowReportModal(true);
    } catch (err) {
      console.error('신고 정보 조회 중 오류:', err);
      setError('신고 정보를 불러오지 못했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveReport = async () => {
    if (!reportTarget?.boardTextId) {
      return;
    }
    if (!reportText.trim()) {
      setError('신고 내용을 입력해주세요.');
      return;
    }
    setSavingReport(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setError('인증 토큰을 가져올 수 없습니다.');
        return;
      }
      const resp = await addBookcommunityBoardTextReport(accessToken, reportTarget.boardTextId, reportText.trim());
      const pr = processApiResponse(resp);
      if (pr.success) {
        closeReportModal();
      } else {
        setError(pr.errorMessage || '신고 저장에 실패했습니다.');
      }
    } catch (err) {
      console.error('신고 저장 중 오류:', err);
      setError('신고 저장에 실패했습니다.');
    } finally {
      setSavingReport(false);
    }
  };

  const handleDeleteReport = async () => {
    if (!reportTarget?.boardTextId) {
      return;
    }
    if (!window.confirm('기존 신고 내용을 삭제하시겠습니까?')) {
      return;
    }
    setDeletingReport(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setError('인증 토큰을 가져올 수 없습니다.');
        return;
      }
      const resp = await deleteBookcommunityBoardTextReport(accessToken, reportTarget.boardTextId);
      const pr = processApiResponse(resp);
      if (pr.success || resp?.errorCode === ERROR_CODES.NOTFOUND) {
        closeReportModal();
      } else {
        setError(pr.errorMessage || '신고 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('신고 삭제 중 오류:', err);
      setError('신고 삭제에 실패했습니다.');
    } finally {
      setDeletingReport(false);
    }
  };

  // 날짜 포맷팅 함수
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit' 
    });
  };


  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (error) {
    return (
      <Wrapper>
        <Content>
          <CommunityContent>
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666', whiteSpace: 'pre-line'}}>
              <p>{error}</p>
              <button 
                onClick={() => fetchFreeBoardData(true)}
                style={{
                  marginTop: '16px',
                  padding: '8px 16px',
                  backgroundColor: '#244AC2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                다시 시도
              </button>
            </div>
          </CommunityContent>
        </Content>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Content>
          <CommunityContent>
                <CommunityHeader>
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                    <BookCount>{totalCount}개의 글</BookCount>
                    <SortDropdown onClick={()=>setSortByNew(!sortByNew)}>
                      {sortByNew ? '최신순' : '오래된순'}
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 4.5L6 7.5L9 4.5" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </SortDropdown>
                  </div>
                </CommunityHeader>
                {freeBoardData.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666' }}>
                    <p>아직 작성된 글이 없습니다.</p>
                  </div>
                ) : (
                  freeBoardData.map((post) => (
                    <BookItem key={post.id} onClick={() => setExpandedPostId(expandedPostId === post.id ? null : post.id)} style={{cursor:'pointer'}}>
                      <BookItemInfo>
                        <div>
                          <BookItemDesc
                            style={expandedPostId === post.id
                              ? { lineHeight: '1.6' }
                              : { lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                          >
                            {post.boardText}
                          </BookItemDesc>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <div style={{fontSize: '12px', color: '#888'}}>
                                { (post.memberId === post.communityOwnerId && '모임장') || (userInfo?.id === post.memberId && '나') || (post.name || post.loginid)} · {formatDate(post.createdAt)}
                              </div>
                              {/* 현재 사용자가 작성한 댓글인지 확인하는 로직이 필요할 수 있음 */}
                              {((userInfo && userInfo?.id == post.communityOwnerId) || userInfo?.id === post.memberId ) && (
                                <>
                                 {userInfo?.id === post.memberId && (<EditButton onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditPost(post);
                                  }}>
                                    <FiEdit3 size={10} />
                                  </EditButton>)}
                                  <DeleteButton onClick={(e) => handleDeletePost(post.id, e)}>
                                    <FiTrash2 size={10} />
                                  </DeleteButton>
                                </>
                              )}

                            </div>
                            <BookItemStats>
                              <StatItem onClick={(e) => handleLikeClick(post.id, e)} style={{cursor: 'pointer'}}>
                                {likedPosts.has(post.id) ? (
                                  <FaHeart size={12} color="#e74c3c" />
                                ) : (
                                  <CiHeart size={12} color="#999" />
                                )}
                                {postLikes[post.id] || 0}
                              </StatItem>
                              <StatItem onClick={(e) => handleCommentClick(post.id, e)} style={{cursor: 'pointer'}}>
                                <PiChatCircleDots size={12} color="#999" />
                                {commentsData[post.id]?.length || post.commentCnt || 0}
                              </StatItem>
                              <StatItem onClick={(e) => openReportModal(post.id, '글', e)} style={{cursor: 'pointer'}}>
                                <FiAlertTriangle size={12} color="#999" />
                              </StatItem>
                            </BookItemStats>
                          </div>
                        </div>
                        
                        {/* 첨부 파일 표시 */}
                        {post.files && post.files.length > 0 && (
                          <AttachmentList onClick={(e) => e.stopPropagation()}>
                            {post.files.map((file, index) => renderAttachment(file, index))}
                          </AttachmentList>
                        )}
                        
                        {/* 댓글 목록 */}
                        {showComments.has(post.id) && (
                          <CommentsContainer>
                            {/* 댓글 로딩 중 */}
                            {loadingComments.has(post.id) && (
                              <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                댓글을 불러오는 중...
                              </div>
                            )}
                            
                            {/* 댓글 목록 표시 */}
                            {!loadingComments.has(post.id) && commentsData[post.id] && (
                              <>
                                {commentsData[post.id].length === 0 ? (
                                  <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                    아직 댓글이 없습니다.
                                  </div>
                                ) : (
                                  commentsData[post.id].map((comment) => (
                                    <CommentItem key={comment.id}>
                                      <CommentHeader>
                                        <CommentHeaderLeft>
                                          <CommentAuthor>
                                            {(comment.memberId === comment.communityOwnerId && '모임장') || (userInfo?.id === comment.memberId && '나') || (comment.name || comment.loginid)}
                                          </CommentAuthor>
                                          <CommentDate>
                                            {formatDate(comment.createdAt)}
                                          </CommentDate>
                                        </CommentHeaderLeft>
                                        <CommentHeaderRight>
                                          {(userInfo?.id === comment.memberId || userInfo?.id === comment.communityOwnerId) && (
                                            <>
                                              {userInfo?.id === comment.memberId && (<EditButton onClick={(e) => {
                                                e.stopPropagation();
                                                setEditingComment({ postId: post.id, comment });
                                                setEditCommentText(comment.boardText || '');
                                                setShowCommentEditModal(true);
                                              }}>
                                                <FiEdit3 size={10} />
                                              </EditButton>)}
                                              <DeleteButton onClick={async (e) => {
                                                e.stopPropagation();
                                                if (!window.confirm('정말로 이 댓글을 삭제하시겠습니까?')) {
                                                  return;
                                                }
                                                try {
                                                  const { accessToken } = await getAccessToken();
                                                  if (!accessToken) return;
                                                  const resp = await deleteBookcommunityDefaultBoardTextComment(accessToken, comment.id);
                                                  const pr = processApiResponse(resp);
                                                  if (pr.success || resp.errorCode === ERROR_CODES.NOTFOUND) {
                                                    commentsData[post.id] = null;
                                                    await fetchComments(post.id);
                                                  } else {
                                                    setError(pr.errorMessage || '댓글 삭제에 실패했습니다.');
                                                  }
                                                } catch (err) {
                                                  console.error('댓글 삭제 중 오류:', err);
                                                  setError('댓글 삭제에 실패했습니다.');
                                                }
                                              }}>
                                                <FiTrash2 size={10} />
                                              </DeleteButton>
                                              <ReportButton onClick={(e) => openReportModal(comment.id, '댓글', e)}>
                                                <FiAlertTriangle size={10} />
                                              </ReportButton>
                                            </>
                                          )}
                                        </CommentHeaderRight>
                                      </CommentHeader>
                                      <CommentContent>
                                        {comment.boardText}
                                      </CommentContent>
                                    </CommentItem>
                                  ))
                                )}
                              </>
                            )}
                            
                            {/* 댓글 입력창 */}
                            <CommentInputContainer>
                              <form onSubmit={(e) => handleCommentSubmit(post.id, e)}>
                                <CommentInputWrapper>
                                  <CommentInput
                                    type="text"
                                    placeholder="답글을 입력해주세요"
                                    value={commentInputs[post.id] || ''}
                                    onChange={(e) => handleCommentInputChange(post.id, e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                  <CommentSubmitButton 
                                    type="submit"
                                    disabled={!commentInputs[post.id]?.trim() || submittingComment.has(post.id)}
                                  >
                                    {submittingComment.has(post.id) ? '작성 중...' : '작성'}
                                  </CommentSubmitButton>
                                </CommentInputWrapper>
                              </form>
                            </CommentInputContainer>
                          </CommentsContainer>
                        )}
                      </BookItemInfo>
                    </BookItem>
                  ))
                )}
                
                {/* 무한 스크롤 로딩 인디케이터 */}
                {isLoadingMore && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    <div>더 많은 글을 불러오는 중...</div>
                  </div>
                )}
                
                {/* 더 이상 데이터가 없을 때 */}
                {!hasMore && freeBoardData.length > 0 && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#999', fontSize: '14px' }}>
                    모든 글을 불러왔습니다.
                  </div>
                )}
          </CommunityContent>
      </Content>
      {showFreeboardEditModal && (
        <BoardEditModalOverlay>
        <BoardEditModal>
          <EditModalHeader>
            <EditModalTitle>글쓰기</EditModalTitle>
            <EditCloseButton onClick={()=>closeFreeboardEditModal(false)}>
              <FaTimes />
            </EditCloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimDetailCommunityFreeboardEditPage bookCommunityId={bookCommunityId} bookCommunityBoardTextId={editingPost.id} onClose={closeFreeboardEditModal} />
          </EditModalContent>
        </BoardEditModal>
        </BoardEditModalOverlay>
      )}

      {showCommentEditModal && editingComment && (
        <CommentEditModalOverlay onClick={()=>{ setShowCommentEditModal(false); setEditingComment(null); }}>
          <CommentEditModalContent onClick={(e)=>e.stopPropagation()}>
            <CommentEditModalTitle>댓글 수정</CommentEditModalTitle>
            <CommentEditTextarea
              value={editCommentText}
              onChange={(e)=>setEditCommentText(e.target.value)}
              placeholder="댓글을 입력해주세요"
              autoFocus
            />
            <CommentEditModalButtons>
              <CommentEditModalButton 
                className="cancel"
                onClick={()=>{ setShowCommentEditModal(false); setEditingComment(null); }}
                disabled={savingCommentEdit}
              >
                취소
              </CommentEditModalButton>
              <CommentEditModalButton 
                className="save"
                onClick={async ()=>{
                  if (!editCommentText.trim()) return;
                  try {
                    setSavingCommentEdit(true);
                    const { accessToken } = await getAccessToken();
                    if (!accessToken) return;
                    const req = { boardText: editCommentText.trim() };
                    const resp = await modifyBookcommunityDefaultBoardTextComment(accessToken, editingComment.comment.id, req);
                    const pr = processApiResponse(resp);
                    if (pr.success) {
                      setShowCommentEditModal(false);
                      setEditingComment(null);
                      commentsData[editingComment.postId] = null;
                      await fetchComments(editingComment.postId);
                    } else {
                      setError(pr.errorMessage || '댓글 수정에 실패했습니다.');
                    }
                  } catch (err) {
                    console.error('댓글 수정 중 오류:', err);
                    setError('댓글 수정에 실패했습니다.');
                  } finally {
                    setSavingCommentEdit(false);
                  }
                }}
                disabled={savingCommentEdit || !editCommentText.trim()}
              >
                {savingCommentEdit ? '저장 중...' : '저장'}
              </CommentEditModalButton>
            </CommentEditModalButtons>
          </CommentEditModalContent>
        </CommentEditModalOverlay>
      )}
      {showReportModal && reportTarget && (
        <CommentEditModalOverlay onClick={closeReportModal}>
          <CommentEditModalContent onClick={(e)=>e.stopPropagation()}>
            <CommentEditModalTitle>{hasExistingReport ? `${reportTarget.label} 신고 수정` : `${reportTarget.label} 신고`}</CommentEditModalTitle>
            <ReportModalTextarea
              value={reportText}
              onChange={(e)=>setReportText(e.target.value)}
              placeholder="신고 내용을 입력해주세요"
              autoFocus
            />
            <CommentEditModalButtons>
              {hasExistingReport && (
                <CommentEditModalButton
                  className="cancel"
                  onClick={handleDeleteReport}
                  disabled={savingReport || deletingReport}
                >
                  {deletingReport ? '삭제 중...' : '삭제'}
                </CommentEditModalButton>
              )}
              <CommentEditModalButton
                className="cancel"
                onClick={closeReportModal}
                disabled={savingReport || deletingReport}
              >
                취소
              </CommentEditModalButton>
              <CommentEditModalButton
                className="save"
                onClick={handleSaveReport}
                disabled={savingReport || deletingReport || !reportText.trim()}
              >
                {savingReport ? '저장 중...' : '저장'}
              </CommentEditModalButton>
            </CommentEditModalButtons>
          </CommentEditModalContent>
        </CommentEditModalOverlay>
      )}
    </Wrapper>
  );
} 